import { render, staticRenderFns } from "./prove.vue?vue&type=template&id=92275780&scoped=true&"
import script from "./prove.vue?vue&type=script&lang=js&"
export * from "./prove.vue?vue&type=script&lang=js&"
import style0 from "./prove.vue?vue&type=style&index=0&id=92275780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92275780",
  null
  
)

export default component.exports